module.exports = __webpack_public_path__ + "img/IMG_2134.beceff7f.jpg";